import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { url, history } from '../../utils/variables';
import { pexios, toast, uploadImages } from '../../utils/functions';
import ImagePickerModal from '../../components/master/ImagePickerModal';
import Maps from '../../components/master/Maps';
import defaultImage from '../../assets/images/default.png';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/master/Modal';
import ImageZoom from '../../components/master/ImageZoom';

export default function Review() {
    const { t } = useTranslation();
    const user = useSelector(store => store.user);
    const { id } = useSelector(store => store.routerData);

    const [report, setReport] = useState({});
    const [images, setImages] = useState([]);
    const [description, setDescription] = useState(false);
    const [loader, setLoader] = useState(false);
    const [showImage , setShowImage] = useState(null);

    const setStatus = useCallback((status) => {
        switch (status) {
            case 3:
                return 'health';
            case 6:
                return 'stock';
            case 10:
                return 'double';
            default:
                return null;
        }
    }, []);

    useEffect(() => {
        pexios('api/v2/get_report_by_id','post',{ id })
            .then(res=>{
                const imageType = setStatus(res.data.data.status);
                setReport(res.data.data);
                setImages(res.data.data.attachments.filter(img => img.filename.includes(`${imageType}_image`)));
            });
    }, [id, setStatus]);

    function addCrashImage(image, done){
        const imageType = setStatus(report.status);
        uploadImages({
            id,
            type: 'report',
            name: `${imageType}_image${images.length + 1}`,
            image,
            done,
            callback: (data) => {
                setImages(prevState => ([
                    ...prevState,
                    data,
                ]));
            }
        });
    }

    function submit() {
        setLoader(true);
        const data = {
            accident_id: report.accident_id,
            report_id: id,
            description: description,
            status: report.status + 1,
        };
        pexios('api/add_review','post', data)
            .then(() => {
                toast(t('Review greeting alert'));
                setTimeout(() => {
                    if (report.status === 10) history.replace(`/edit-report/double`);
                    else history.replace(`/report-single/${id}`);
                }, 500);
            });
    }

    return (
        <>
        <div className='content expertMap'>
            <p className='text-justify mt20'>
                {t('Expert name')}
                {` ${user.full_name} `}
                {t('File')}
                {` ${ report.status === 3 ? t('Health visit') : report.status === 6 ? t('Give damaged accessories') : t('Archives list') } `}
                {t('File number')}
                {` ${id} `}
                {t('Dispatch file')}
            </p>
            <div className='mt20'>
                {
                    (report.lat && report.lng) &&
                    <Maps loc={[report.lat, report.lng]} />
                }
            </div>
            <div className='input-parent rtl mt20'>
                        <textarea
                            rows='4'
                            placeholder={t('Description')}
                            onChange={ (e) => setDescription(e.target.value) }
                        />
            </div>
            <div className='gridParent mt20'>
                <div className='crashGrid'>
                    <p>{t('Images')} { report.status === 3 ? t('Health visit') : report.status === 6 ? t('Give damaged accessories') : t('Archives list') }</p>
                    <div className='crashGridChild'>
                        {
                            images.map((img) => (
                                <div className='imageBox' key={img.id}>
                                    <img
                                        src={`${url}/files?uid=${img.uid}&width=65&height=65`}
                                        className='img'
                                        alt='img'
                                        onClick={() =>setShowImage(img.uid)}
                                    />
                                </div>
                            ))
                        }
                        <div className='imageBox'>
                            <ImagePickerModal
                                renderBtn={<img src={defaultImage} className='img' alt='img' />}
                                disableGallery
                                upload={addCrashImage}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <button className='btn btn-block btn-green mt20 btn-circle'  disabled={ loader && 'disabled' } onClick={() => submit()}>
                {
                    loader ?
                        <i className='fas fa-spinner fa-spin' /> :
                        report.status === 10 ?
                            t('Next step') :
                            t('Final confirm')
                }
            </button>
        </div>
        <Modal visible={showImage}>
            <div className='image-modal'>
                <i className='fas fa-times'
                    onClick={() => setShowImage(null)}
                />
                <ImageZoom imgUid={showImage}/>
            </div>
        </Modal>
        </>
    );
}
